<div class="relative w-full top-0 h-[4.6rem] bg-gray-900"></div>

<div [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'">
  <div class="flex items-center justify-center mt-5">
    <h1
      class="text-center inline-block text-xl border border-black px-5 py-1 rounded-full"
    >
      {{ "suggestedBlogs" | transloco }}
    </h1>
  </div>

  <!-- ERROR -->
  <div *ngIf="errorMsg" class="w-full flex items-center justify-center py-16">
    <div class="text-red-600">
      {{ "loadError" | transloco : { default: "Failed to load blogs." } }} ({{
        errorMsg
      }})
    </div>
  </div>

  <ng-container *ngIf="!errorMsg">
    <!-- DATA or LOADING -->
    <ng-container *ngIf="blogs$ | async as blogs; else loadingTpl">
      <div
        class="px-5 lg:px-10 xl:px-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5 lg:gap-10 xl:gap-14 mt-10"
      >
        <div
          class="shadow-lg rounded-t-xl h-full"
          *ngFor="let item of blogs; trackBy: trackById"
        >
          <a
            class="pt-5 hover:text-[#E60027] cursor-pointer"
            [routerLink]="['/', activeLang, 'blogs', item._id]"
            [dir]="activeLang === 'AR' ? 'rtl' : 'ltr'"
          >
            <div class="w-full h-64 mx-auto overflow-hidden">
              <img
                *ngIf="item.image?.url !== 'none'"
                [src]="item.image?.url"
                loading="lazy"
                alt="Image 1"
                class="center object-cover w-full h-full grayscale-0 hover:grayscale"
              />
            </div>
            <div class="p-2 mt-3">
              <h2 class="w-full font-bold text-center" style="font-size: 1rem">
                {{ item.title?.[activeLang] }}
              </h2>
            </div>
          </a>
        </div>
      </div>

      <!-- EMPTY -->
      <div
        class="w-full flex items-center justify-center py-20"
        *ngIf="blogs.length === 0"
      >
        <div class="text-gray-600">
          {{ "noResults" | transloco : { default: "No blogs found." } }}
        </div>
      </div>
    </ng-container>

    <!-- LOADING -->
    <ng-template #loadingTpl>
      <div class="w-full flex items-center justify-center py-24">
        <div class="inline-flex items-center gap-3">
          <span
            class="w-6 h-6 rounded-full border-2 border-gray-300 border-t-transparent animate-spin"
          ></span>
          <span class="text-gray-600">{{
            "loading" | transloco : { default: "Loading..." }
          }}</span>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>

<div class="my-60"></div>
